define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CacheStorage = void 0;
    class CacheStorage {
        constructor(namespace) {
            this.namespace = namespace;
        }
        get(key) {
            return window.caches.open(this.namespace)
                .then(cache => cache.match(new Request(this.namespace + '/' + key)))
                .then(resp => (typeof resp === 'undefined') ? null : resp.json().then((r) => r));
        }
        put(key, value) {
            const resp = new Response(JSON.stringify(value), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return window.caches.open(this.namespace)
                .then(cache => cache.put(new Request(this.namespace + '/' + key), resp));
        }
        delete(key) {
            return window.caches.open(this.namespace)
                .then(cache => cache.delete(new Request(this.namespace + '/' + key)));
        }
        clear() {
            return window.caches.delete(this.namespace);
        }
    }
    exports.CacheStorage = CacheStorage;
});
